import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    quote: "Extremely professional and knowledgeable - Highly recommend",
    author: "Tommy Parilla",
    business: "Google Reviewer",
    platform: "Google Reviews",
    rating: 5,
    featured: true,
  },
  {
    quote: "Tibs Taps has a specialized ability to identify and eliminate yeast and mold buildup that others often miss. True professionals.",
    author: "Boston Globe Feature",
    business: "Industry Expert Review",
    platform: "Media",
    rating: 5,
    featured: false,
  },
  {
    quote: "Whenever someone asks for draft line cleaning recommendations for home bars in Southern NH, Tibs Taps is always the first name that comes up.",
    author: "NH Eats Community",
    business: "Facebook Group",
    platform: "Community",
    rating: 5,
    featured: false,
  },
];

const platformColors = {
  "Google Reviews": "text-blue-400",
  "Facebook": "text-blue-500",
  "Yelp": "text-red-400",
  "Media": "text-purple-400",
  "Community": "text-green-400",
};

export default function TestimonialsSection() {
  const featuredTestimonials = testimonials.filter(t => t.featured);
  const otherTestimonials = testimonials.filter(t => !t.featured);

  return (
    <section id="testimonials" className="py-24 bg-[#0A0A0A]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div
          className="text-center mb-16"
        >
          <p className="overline mb-4" data-testid="testimonials-overline">What Our Customers Say</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white mb-4" data-testid="testimonials-heading">
            Trusted by <span className="gold-text">150+ Establishments</span>
          </h2>
          <p className="text-[#A1A1AA] max-w-2xl mx-auto text-lg">
            From local taverns to craft breweries, see why bars and restaurants across 
            New England trust Tibs Taps with their draft systems.
          </p>
          
          {/* Trust Badge */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <div className="flex items-center gap-1 px-4 py-2 bg-[#141414] border border-[#27272A] rounded-full">
              <span className="text-[#D4AF37] font-bold">100%</span>
              <span className="text-[#A1A1AA] text-sm">Facebook Recommendation Rate</span>
            </div>
          </div>
        </div>

        {/* Featured Testimonials */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {featuredTestimonials.map((testimonial) => (
            <div
              key={testimonial.author}
              className="relative p-8 bg-[#141414] border border-[#27272A] rounded-2xl card-hover"
              data-testid={`testimonial-featured-${testimonial.author}`}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-20">
                <Quote className="w-12 h-12 text-[#D4AF37]" />
              </div>
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`star-f-${i}`} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-white text-lg mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white font-medium">{testimonial.author}</p>
                  <p className="text-[#A1A1AA] text-sm">{testimonial.business}</p>
                </div>
                <span className={`text-xs font-medium px-3 py-1 rounded-full bg-white/5 ${platformColors[testimonial.platform]}`}>
                  {testimonial.platform}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Other Testimonials Grid */}
        <div
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {otherTestimonials.map((testimonial) => (
            <div
              key={testimonial.author}
              className="p-6 bg-[#141414] border border-[#27272A] rounded-xl card-hover"
              data-testid={`testimonial-${testimonial.author}`}
            >
              {/* Rating */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`star-${i}`} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-[#A1A1AA] text-sm mb-4 line-clamp-4">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="pt-4 border-t border-[#27272A]">
                <p className="text-white text-sm font-medium">{testimonial.author}</p>
                <p className="text-[#A1A1AA] text-xs">{testimonial.business}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
